/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.1.4
* 
*******************************************************************************/
import _someInstanceProperty from"@babel/runtime-corejs3/core-js-stable/instance/some";import isObject from"./isObject";import isString from"./isString";const deepSearch=function(e,t){if(!isObject(e)||!isString(t))return;let r=e;const s=t.split(".");return _someInstanceProperty(s).call(s,(e=>(r=r[e],!r))),r};export default deepSearch;